import { useState } from 'react';
import Button from '../../../components/button/Button';
import Card from '../../../components/card/Card';
import Icon from '../../../components/icon/Icon';
import P from '../../../components/texts/p/P';
import { CONTRACTS_STATUSES } from '../../../utils/Constants';
import Spinner from '../../../components/Spinner/spinner';
import { getMimeType } from '../../../utils/Utils';
import { downloadContractFile } from '../../../services/InstrumentationService';
import { contractData } from '../../../types/interfaces';

interface ContractStatusProps {
  cuit: string | undefined;
  applicationId: string | undefined;
  contract: contractData;
  onDelete: Function;
}

const ContractStatus: React.FC<ContractStatusProps> = ({ cuit, applicationId, contract, onDelete }) => {

  const statusMap = {
    [CONTRACTS_STATUSES.pending.label]: {
      text: 'Esperando firma en signatura',
      icon: 'clock_outline',
      variant: 'warning'
    },
    [CONTRACTS_STATUSES.rejected.label]: {
      text: contract.signature_type_code === 'MAN' ? 'Contrato con firma manuscrita rechazado' : 'Rechazado en signatura',
      icon: 'cancel_outline',
      variant: 'danger'
    },
    [CONTRACTS_STATUSES.signed.label]: {
      text: contract.signature_type_code === 'MAN' ? 'Contrato con firma manuscrita aprobado' : 'Firmado en signatura',
      icon: 'check_circle_outline',
      variant: 'success'
    },
  };

  const statusData = statusMap[contract.status_code];
  const [isViewLoading, setIsViewLoading] = useState<boolean>(false);
  const handleViewPdf = () => {
    setIsViewLoading(true)
    downloadContractFile(cuit, applicationId, contract.asset_file_path).then((response) => {
      if (response.success) {
        const mimeType = getMimeType(contract.asset_file_path);
        const fileBlob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(fileBlob);
        if (
          mimeType.startsWith('application/pdf') ||
          mimeType.startsWith('image/')
        ) {
          window.open(url, '_blank');
        } else {
          const a = document.createElement('a');
          a.href = url;
          a.download = contract.asset_file_path;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      }
      setIsViewLoading(false);
    });
  };

  return (
    <Card>
      {contract.isLocal ?
        <Card variant='neutral' border modifier='inverted' height='48px' display='flex' alignItems='center' justifyContent='space-between' spacing={{ left: '2', right: '2' }}>
          <P variant='neutral'>
            {contract.asset_file_path}
          </P>
          <Icon name='delete_outline' variant='neutral' cursor='pointer' onClick={() => onDelete(contract.id)} />
        </Card>
        :
        <Card width='100%' display='flex' gap='16px'>
          <Card width='80%' variant={statusData?.variant} border modifier='inverted' height='48px' display='flex' alignItems='center' spacing={{ left: '2', right: '2' }}>
            <Icon name={statusData?.icon} variant={statusData?.variant} />
            <Card width='100%'>
              <P type='2' weight='bold' align='center' variant={statusData?.variant}>{statusData?.text}</P>
            </Card>
          </Card>
          {(contract.signature_type_code === 'MAN' && contract.status_code !== 'REJ') && (
            <Button
              size='md'
              variant='secondary'
              onClick={() => onDelete(contract.id)}
            >
              <Card
                variant='none'
                margin={{
                  top: '2',
                  left: '0',
                  bottom: '2',
                  right: '0',
                }}
                height='28px'
              >
                {isViewLoading ?
                  <Spinner size="sm" />
                  :
                  <Icon
                    variant='neutral'
                    name='delete_outline'
                    cursor='pointer'
                  />
                }
              </Card>
            </Button>
          )}
          <Button
            size='md'
            variant='secondary'
            onClick={handleViewPdf}
          >
            <Card
              variant='none'
              margin={{
                top: '2',
                left: '0',
                bottom: '2',
                right: '0',
              }}
              height='28px'
            >
              {isViewLoading ?
                <Spinner size="sm" />
                :
                <Icon
                  variant='neutral'
                  name='view_outline'
                  cursor='pointer'
                />
              }
            </Card>
          </Button>
        </Card>
      }
    </Card>
  );
};

export default ContractStatus;